/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { Button, Dropdown, Menu } from 'antd';
import IconEmpty from '../../../../assets/Images/icons/empty';
import DataFlowService from '../../../../services/DataFlow.service';
import { useTranslation } from 'react-i18next';
import ModalActivity from '../DataflowDetail/ModalActivity';
import ModalSuccess from '../../../../components/Shared/modal/success';
import ModalDelete from '../../../../components/Shared/modal/delete';
import useNotify from '../../../../context/Notification/useNotify';
import { useNavigate } from 'react-router-dom';
import UserService from '../../../../services/UserService';
import { STATUS_ID } from '../../STATUS_ID';
import { STATUS_ID as STATUS_ROPA } from '../../../ropa/STATUS_ID';
import { ROUTER } from '../../../../constants/router';
import usePermission from '../../../../hooks/usePermission';

export default function ActivityProcess({ businessProcessId, dataFlowInfo }) {
    const [openSuccess, setOpenSuccess] = useState(false);
    const [openActivityModal, setOpenActivityModal] = useState(false);
    const { t } = useTranslation();
    const [activityList, setActivityList] = useState([]);
    const [openDelete, setOpenDelete] = useState(false);
    const [activityId, setActivityId] = useState('');
    const [total, setTotal] = useState(0);
    const [activityMode, setActivityMode] = useState('addActivity');
    const [activityData, setActivityData] = useState();

    const notify = useNotify();
    const navigate = useNavigate();

    // Role
    const role = UserService.role().toLowerCase();
    const admin = ['admin', 'auditor', 'super admin'].includes(role);
    const { isAuditor } = usePermission();

    const getActivityList = async () => {
        await DataFlowService.getActivityList(businessProcessId)
            .then((res) => {
                if (res?.data?.resultData) {
                    setActivityList(res?.data?.resultData?.activityList);
                    setTotal(res?.data?.resultData?.total);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const deleteActivity = async (id) => {
        await DataFlowService.deleteActivity(id)
            .then((res) => {
                notify({
                    title: t('common.Success'),
                    description: t('Successfully deleted data'),
                });
                setOpenDelete(false);
                getActivityList();
            })
            .catch((err) => {
                console.log(err);
            });
    };

    useEffect(() => {
        getActivityList();
    }, []);

    const menu = (index, id, statusId) => {
        let item = [
            {
                label: t('common.View'),
                onClick: () => {
                    navigate(`${ROUTER.DS_INVENTORY.ROPA}/${id}/view`);
                },
            },
            {
                label: t('common.Edit'),
                onClick: () => {
                    setOpenActivityModal(true);
                    setActivityMode('editActivity');
                    setActivityData(activityList[index]);
                },
            },
        ];
        if (dataFlowInfo) {
            if (checkMenu(statusId)) {
                item.push({
                    label: t('common.Delete'),
                    onClick: () => {
                        setActivityId(id);
                        setOpenDelete(true);
                    },
                });
            }
        }
        // view : revise draft wait reviewed
        // edit : revise draft wait reviewed
        // delete : wait reviewed

        return <Menu items={item} />;
    };

    const hiddenAdd = () => {
        if (isAuditor) {
            return true;
        }

        if (admin) {
            if (
                dataFlowInfo?.isReviewed === '1' &&
                dataFlowInfo?.statusId === STATUS_ID.REVIEWED
            ) {
                return false;
            } else if (
                dataFlowInfo?.isReviewed === '1' &&
                dataFlowInfo?.statusId === STATUS_ID.REVISE
            ) {
                return false;
            } else return true;
        } else {
            // user
            if (
                dataFlowInfo?.isReviewed === '1' &&
                dataFlowInfo?.statusId === STATUS_ID.REVISE
            ) {
                return false;
            } else if (
                dataFlowInfo?.isReviewed === '1' &&
                dataFlowInfo?.statusId === STATUS_ID.REVIEWED
            ) {
                return false;
            } else return true;
        }
    };

    const hiddenAdd_ropa = (statusId) => {
        if (admin) {
            if (
                statusId === STATUS_ROPA.DRAFT &&
                dataFlowInfo?.statusId === STATUS_ID.WAITING_FOR_REVIEW
            ) {
                return true;
            } else if (
                statusId === STATUS_ROPA.REVISE &&
                dataFlowInfo?.statusId === STATUS_ID.WAITING_FOR_REVIEW
            ) {
                return true;
            } else if (statusId === STATUS_ROPA.REVIEWED) {
                return false;
            } else return false;
        } else {
            // user
            if (
                statusId === STATUS_ROPA.DRAFT &&
                dataFlowInfo?.statusId === STATUS_ID.REVISE
            ) {
                return true;
            } else if (
                statusId === STATUS_ROPA.REVISE &&
                dataFlowInfo?.statusId === STATUS_ID.REVISE
            ) {
                return true;
            } else return false;
        }
    };

    const checkMenu = (statusId) => {
        if (!admin) {
            // user
            // Reviewed
            // Waiting for review
            if (
                dataFlowInfo?.isReviewed === '1' &&
                (statusId === STATUS_ROPA.WAITING_FOR_REVIEW ||
                    statusId === STATUS_ROPA.REVIEWED)
            ) {
                return false;
            } else return true;
        }
        return true;
    };

    return (
        <div className="col-span-1 bg-white rounded-xl p-4 py-6 my-4">
            <div
                className="text-[17px] font-semibold pb-2"
                style={{ borderBottom: '3px solid #F4F6FC' }}
            >
                {t('dataFlow.ProcessingActivity')}
            </div>
            <div>
                <div className="flex justify-between my-2 text-xs">
                    <div className="font-semibold text-sm text-[#65707A]">
                        {t('TotalItems', { length: total })}
                    </div>
                    <Button
                        hidden={hiddenAdd()}
                        type="link"
                        onClick={() => {
                            setOpenActivityModal(true);
                            setActivityMode('addActivity');
                        }}
                        style={{ color: '#1890FF' }}
                        className="text-sm"
                    >
                        {t('RoPA.AddActivity')}
                    </Button>
                </div>
            </div>
            {activityList.length > 0 ? (
                <div className="overflow-auto max-h-[200px]">
                    {activityList.map((item, index) => (
                        <div
                            key={item?.activityId}
                            style={{ background: '#F5F6FF' }}
                            className="px-4 rounded-md mt-4"
                        >
                            <div className="flex justify-between">
                                <div className="font-semibold py-3">
                                    <div className="align-middle inline-block whitespace-normal">
                                        {item.activityName}
                                    </div>
                                </div>
                                <div
                                    className="font-medium py-3 cursor-pointer"
                                    style={{ color: '#1890FF' }}
                                >
                                    {hiddenAdd_ropa(item.status) ? (
                                        <div
                                            className="hover:opacity-80 rounded-md"
                                            style={{
                                                backgroundColor: '#EEE5FF',
                                            }}
                                        >
                                            <Dropdown
                                                placement="bottomRight"
                                                overlay={menu(
                                                    index,
                                                    item?.activityId,
                                                    item.status
                                                )}
                                            >
                                                <svg
                                                    width={32}
                                                    height={25}
                                                    viewBox="0 0 32 26"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <rect
                                                        width={32}
                                                        height={32}
                                                        rx={6}
                                                    />
                                                    <path
                                                        d="M19.75 16C19.75 17.0312 20.5937 17.875 21.625 17.875C22.6562 17.875 23.5 17.0313 23.5 16C23.5 14.9687 22.6563 14.125 21.625 14.125C20.5937 14.125 19.75 14.9687 19.75 16Z"
                                                        fill="#7B67FB"
                                                    />
                                                    <path
                                                        d="M17.875 16C17.875 14.9687 17.0313 14.125 16 14.125C14.9687 14.125 14.125 14.9687 14.125 16C14.125 17.0312 14.9687 17.875 16 17.875C17.0312 17.875 17.875 17.0313 17.875 16Z"
                                                        fill="#7B67FB"
                                                    />
                                                    <path
                                                        d="M12.25 16C12.25 14.9687 11.4063 14.125 10.375 14.125C9.34375 14.125 8.5 14.9687 8.5 16C8.5 17.0312 9.34375 17.875 10.375 17.875C11.4062 17.875 12.25 17.0313 12.25 16Z"
                                                        fill="#7B67FB"
                                                    />
                                                </svg>
                                            </Dropdown>
                                        </div>
                                    ) : (
                                        <div
                                            onClick={() =>
                                                navigate(
                                                    `${ROUTER.DS_INVENTORY.ROPA}/${item?.activityId}/view`
                                                )
                                            }
                                            className="flex items-center"
                                        >
                                            <ViewIcon />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="grid items-center justify-center">
                    <IconEmpty />
                </div>
            )}

            <ModalDelete
                open={openDelete}
                text={t('modalActivityDelete')}
                handelOk={() => {
                    deleteActivity(activityId);
                }}
                handelClose={() => setOpenDelete(false)}
            />

            <ModalActivity
                mode={activityMode}
                open={openActivityModal}
                openSuccess={openSuccess}
                setOpenSuccess={setOpenSuccess}
                activityData={activityData}
                getActivityList={getActivityList}
                departmentId={dataFlowInfo?.departmentId}
                handelClose={() => {
                    setOpenActivityModal(false);
                    setActivityData(null);
                    setActivityMode('');
                }}
            />

            <ModalSuccess
                open={openSuccess}
                handelClose={() => setOpenSuccess(false)}
            />
        </div>
    );
}

const ViewIcon = () => {
    return (
        <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="30" height="30" rx="6" fill="#EEE5FF" />
            <g clipPath="url(#clip0_5460_60457)">
                <path
                    d="M15 16.875C16.0355 16.875 16.875 16.0355 16.875 15C16.875 13.9645 16.0355 13.125 15 13.125C13.9645 13.125 13.125 13.9645 13.125 15C13.125 16.0355 13.9645 16.875 15 16.875Z"
                    fill="#7B67FB"
                />
                <path
                    d="M22.0029 14.8406C21.4516 13.4145 20.4945 12.1812 19.2499 11.2932C18.0052 10.4051 16.5277 9.90121 14.9998 9.84375C13.4719 9.90121 11.9944 10.4051 10.7497 11.2932C9.50512 12.1812 8.548 13.4145 7.99668 14.8406C7.95944 14.9436 7.95944 15.0564 7.99668 15.1594C8.548 16.5855 9.50512 17.8188 10.7497 18.7068C11.9944 19.5949 13.4719 20.0988 14.9998 20.1562C16.5277 20.0988 18.0052 19.5949 19.2499 18.7068C20.4945 17.8188 21.4516 16.5855 22.0029 15.1594C22.0402 15.0564 22.0402 14.9436 22.0029 14.8406ZM14.9998 18.0469C14.3972 18.0469 13.8081 17.8682 13.307 17.5334C12.806 17.1986 12.4155 16.7227 12.1849 16.166C11.9542 15.6092 11.8939 14.9966 12.0115 14.4056C12.129 13.8145 12.4192 13.2716 12.8453 12.8455C13.2714 12.4194 13.8143 12.1292 14.4054 12.0117C14.9964 11.8941 15.609 11.9544 16.1658 12.1851C16.7225 12.4157 17.1984 12.8062 17.5332 13.3072C17.868 13.8083 18.0467 14.3974 18.0467 15C18.0454 15.8077 17.724 16.582 17.1529 17.1531C16.5818 17.7242 15.8075 18.0456 14.9998 18.0469Z"
                    fill="#7B67FB"
                />
            </g>
            <defs>
                <clipPath id="clip0_5460_60457">
                    <rect
                        width="15"
                        height="15"
                        fill="white"
                        transform="translate(7.5 7.5)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};
